module.exports = __webpack_public_path__ + "static/media/BirthEducation.0595a234.svg";